import React, { useEffect, useState, useMemo } from "react";
import { useAuth } from "../../context/AuthContext";
import { fetchDashboard } from "../../services/Dashboard/dashboardService";
import { DashoardResponse } from "../../types/dashboardResponse";
import { FuelConsumption } from '../../types/fuelConsumptionResponse';
import { HorasUnidadFrio } from '../../types/horasUnidadFrioResponse'
import { DailyStats } from '../../types/dailyStatsResponse'
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from 'recharts';


const DailyStatsTable: React.FC = () => {
    const { user } = useAuth();
    const [fuelConsumption, setFuelConsumption] = useState<FuelConsumption | null>(null);
    const [horasUnidadFrio, setHorasUnidadFrio] = useState<HorasUnidadFrio | null>(null);
    const [dailyStats, setDailyStats] = useState<DailyStats | null>(null);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const userRole = useMemo(()=> user?.User.role, [user]);

    console.log('DailyStatsTable, UserRole en el useMemo: ', userRole);


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError("");
            try {
                const response: DashoardResponse = await fetchDashboard(userRole || '');

                setFuelConsumption(response?.fuelConsumption || {data: []});
                setHorasUnidadFrio(response?.horasUnidadFrio || {data: []});
                setDailyStats(response?.dailyStats || {data: [], message: ""});
                
            } catch (error: any) {
                setError('Error al conectar con el servidor: ' + error.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [userRole]);

    const dailyStatsData = dailyStats?.data.map((stat)=> ({
        fecha: new Date(stat.Fecha).toLocaleDateString(),
        vehiculos: stat.VehiculosAtendidos,
        litros: stat.LitrosDespachados,
        galones: stat.GalonesDespachados
    }));


    if (loading) return <p>Cargando datos...</p>;
    if (error) return <p>Error: {error}</p>;


    return (
        <div className="container mt-4">
            <div className="row g-4">
                {dailyStats?.data && dailyStats.data.length > 0 && (
                    <div className="col-md-6"  >
                        <div className="card shadow-sm" hidden>
                            <div className="card-header bg-primary text-white">
                                <h5 className="card-title mb-0">Estadísticas Diarias</h5>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Pistero</th>
                                                <th>Vehículos</th>
                                                <th>Litros</th>
                                                <th>Galones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {dailyStats.data.map((stat, index) => (
                                                <tr key={index}>
                                                    <td>{new Date(stat.Fecha).toLocaleDateString()}</td>
                                                    <td>{stat.Pistero}</td>
                                                    <td>{stat.VehiculosAtendidos}</td>
                                                    <td>{stat.LitrosDespachados}</td>
                                                    <td>{stat.GalonesDespachados}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                        </div>
                        <ResponsiveContainer width="100%" height={400}>
                            <BarChart data={dailyStatsData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="fecha"/>
                                <YAxis />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="vehiculos" fill="#8884d8" name="Vehiculos"/>
                                <Bar dataKey="litros" fill="#82ca9d" name="Litros"/>
                                <Bar dataKey="galones" fill="#ffc658" name="Galones"/>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                )}
                {fuelConsumption?.data && fuelConsumption.data.length > 0 && (
                    <div className="col-md-6">
                        <div className="card shadow-sm">
                            <div className="card-header bg-success text-white">
                                <h5 className="card-title mb-0">
                                    Consumo de combustible
                                </h5>
                            </div>
                            <div className="card-body" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                <table className="table table-stripped table-hover">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Placa</th>
                                            <th>Litros</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fuelConsumption.data.map((fuel, index) => (
                                            <tr key={index}>
                                                <td>{fuel.Placa}</td>
                                                <td>{fuel.Litros}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
                {horasUnidadFrio?.data && horasUnidadFrio.data.length > 0 && (
                    <div className="col-md-6">
                        <div className="card shadow-sm">
                            <div className="card-header bg-info text-white">
                                <h5 className="card-title sm-0">Horas de Unidad de Frio</h5>
                            </div>
                            <div className="card-body">
                                <table className="table table-striped table-hover">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Placa</th>
                                            <th>Horas</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {horasUnidadFrio.data.map((hora, index) => (
                                            <tr key={index}>
                                                <td>{hora.Placa}</td>
                                                <td>{hora.HorasUnidadFrio}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                )}
            </div>

        </div>
    );
};


export default DailyStatsTable;
